import React, { Component } from "react";
import { PageHeader } from "react-bootstrap";
import { Row, Col, Button, FormGroup, Tabs, Tab, FormControl, Table, Modal, Label, Glyphicon } from "react-bootstrap";
import { ToastContainer, ToastStore } from 'react-toasts';
import moment from 'moment';

import './style.css';

import UsersService from "../../services/users-service";
import FormdataService from "../../services/formdata-service";
import FormsService from '../../services/forms-service';
import DispatchService from '../../services/dispatches-service';
import EventWidget from "../../components/widgets/event-widget";

import AddDispatch from "../../components/dispatch-add-dispatch";
import DispatchArchive from "../../components/dispatch-archive";
import AlertModal from "../../components/alert-modal";
import _ from 'underscore';

import Loading from "../../components/loading";

class Dispatch extends Component {

    constructor(props, context) {
        super(props, context);

        this.tabs = [
            {
                type:'view',
                key:'archives',
                label:'Archives',
                removable:false
            },{
                type:'view',
                key:'status',
                label:'Status',
                removable:false
            },{
                type:'view',
                key:'maps',
                label:'Maps',
                removable:false
            }
        ]

        this.state = {
            show: false,
            data: null,
            storedCredenials: UsersService.sharedInstance.getStoredCredentials(),
            incident_types: [],
            facilities: [],
            facility_locations: [],
            auto_emails: [],
            eventKey: 2,
            onEditMode: false,
            itemToEdit: null,
            onDeleteMode: false,
            users_on_duty: [],
            forms:[],
            tabs:this.tabs,
            tab:'archives',
            search:'',
            selected:[],
            reload:false,
            itemToEdit:null,
            dispatches:[],
            call_types:[],
            linkingDispatch: false,

        }

        this.archiveChild = React.createRef();
        this.editTabRendered = false;

        this.timer = null;
        this.handleSelect = this.handleSelect.bind(this);
        this.handleEditIncident = this.handleEditIncident.bind(this);
        this.deleteIncidents = this.deleteIncidents.bind(this);
        this.editTabTitle = this.editTabTitle.bind(this);
        this.showConfirmationModal = this.showConfirmationModal.bind(this);
        this.handleContinueButton = this.handleContinueButton.bind(this);
        this.handleExitButton = this.handleExitButton.bind(this);
        this.getUsersOnDuty = this.getUsersOnDuty.bind(this);
        this.openEditTab = this.openEditTab.bind(this);
        this.getDispatches = this.getDispatches.bind(this);
        this.setSetSettingsModal = this.setSetSettingsModal.bind(this);
        this.setShowMergeModal = this.setShowMergeModal.bind(this);
    }

    componentWillMount(){
        this.getFormDataByType("Call_Type");
        this.getFormDataByType("Facility");
        this.getFormDataByType("Facility_Location");
        this.getFormDataByType("Auto_Email");
        this.getUsersOnDuty();
        this.getDispatches();
      }

    componentDidMount(){
        this.getForms();

    }

    renderTabContent = (data,mainKey) =>{
        const {type,key,label} = data;
        const {search,selected,reload} = this.state;

        if(type === 'new'){
            const {index}= data;
            const tabKey = `new-${index}`;

            return (
                <Tab eventKey={tabKey} title={label} className='incident-tab' key={tabKey} onSelect={() => this.setState({ tab:tabKey })}>
                    <AddDispatch
                        facilities={this.state.facilities}
                        facility_locations={this.state.facility_locations}
                        auto_emails={this.state.auto_emails}
                        changeTab={this.handleChangeTab}
                        users_on_duty={this.state.users_on_duty}
                        forms={this.state.forms}
                        onCancelTab={() => this.onCancelNewTab(mainKey)}
                        getDispatches={this.getDispatches}
                        call_types={this.state.call_types}
                    />
                </Tab>
            )
        }else if(type === 'view'){
            if(key === 'archives'){
                return (
                    <Tab eventKey={'archives'} title={label} className='incident-tab' key={key} onSelect={() => this.setState({ tab:key })}>
                        <DispatchArchive
                            ref={this.archiveChild}
                            editMode={this.handleEditIncident}
                            search={search}
                            selected={selected}
                            reload={reload}
                            onSelect={this.onSelectDispatch}
                            openEditTab={this.openEditTab}
                            dispatches={this.state.dispatches}
                            getDispatches={this.getDispatches}
                            showMergeModal={this.state.showMergeModal}
                            setShowMergeModal={this.setShowMergeModal}
                        />
                    </Tab>
                )
            }else{
                return (
                    <Tab eventKey={key} title={label} className='incident-tab' key={key} onSelect={() => this.setState({ tab:key })}>
                    </Tab>
                )
            }
        }else if(type === 'edit'){
          const {index}= data;
          const tabKey = `edit-${index}`;

          return (
              <Tab eventKey={tabKey} title={label} className='incident-tab' key={tabKey} onSelect={() => this.setState({ tab:tabKey })} title={this.editTabTitle(mainKey)}>
                  <AddDispatch
                      facilities={this.state.facilities}
                      facility_locations={this.state.facility_locations}
                      auto_emails={this.state.auto_emails}
                      changeTab={this.handleChangeTab}
                      users_on_duty={this.state.users_on_duty}
                      forms={this.state.forms}
                      onCancelTab={() => this.onCancelEditTab(mainKey)}
                      itemToEdit={this.state.itemToEdit}
                      getDispatches={this.getDispatches}
                      setSetSettingsModal={this.setSetSettingsModal}
                      call_types={this.state.call_types}
                      onEdit={() => this.onEditDispatch(mainKey)}
                  />
              </Tab>
          )
        }

        return null;
    }

    onCancelNewTab = (key) =>{
        const {tabs} = this.state;

        tabs.splice(key,1);

        this.setState({ tabs });
    }

    onCancelEditTab = (key) =>{
        const {tabs} = this.state;

        let count = 0;

        let guiltyTab = _.find(tabs, (tab)=>{return tab.index === key});
        if(guiltyTab) {
            tabs.splice(guiltyTab.index, 1);
            this.setState({ 
                tabs,
                tab:'archives'
            });
        } else {
          ToastStore.error("Could not find tab: ", key)
        }

    }

    onNewDispatch = (e) =>{
        const {tabs} = this.state;
        let count = 0;
        let index = 0;

        for(let x = 0; x < tabs.length; x++){
            const {type} = tabs[x];

            if(type === 'new'){
                count++;
                index = x;
            }
        }

        if(count >= 3){
            ToastStore.error('Maximum of 3 New Dispatch at a time');
        }else{
            const date = moment();
            tabs.splice(
                (index === 0 ? 0 : index + 1),
                0,
                {
                    date,
                    type:'new',
                    index:count,
                    key:'new-dispatch',
                    label:date.format('hh:mm A'),
                    removable:true
                }
            );

            this.setState({
                tabs,
                tab:'new-' + index
            });
        }
    }

    onEditDispatch = (key) =>{
        const {tabs} = this.state;

        if(tabs[key]){
            tabs[key].hasEdit = true;

            this.setState({ tabs });
        }
    }

    render(){
        const {tab,tabs} = this.state;

        return(
                <div classID="incident-page">
                    <Row className="widget-top-container">
                      <Col md={5} style={{backgroundColor: "white"}}>
                        <EventWidget events={this.props.events}/>
                      </Col>
                    </Row>
                    <Row className="main-settings-content">
                        <Col>
                            <div className="settings-header">
                                <h2 className="header-title left-header">Dispatch</h2>
                                {this.renderArchiveButtons()}
                            </div>
                            <div className="tab-container">
                                <Tabs defaultActiveKey={tab} activeKey={tab} id='incidents-tab'
                                      onSelect={(tab) => {
                                            if(tab === "addNewTab") {
                                                this.onNewDispatch();
                                            } else {
                                              this.setState({ tab })
                                            }

                                          }}>
                                    {
                                        tabs.map((value,key) => {
                                            return this.renderTabContent(value,key)
                                        })
                                    }
                                    <Tab
                                        key='dispatch-action'
                                        className='incident-tab'
                                        eventKey={"addNewTab"}
                                        title={
                                            (
                                                <Glyphicon
                                                    glyph='plus'
                                                    style={{cursor:'pointer'}}

                                                />
                                            )
                                        }
                                    >
                                    </Tab>
                                </Tabs>
                            </div>
                        </Col>
                    </Row>
                    <ToastContainer store={ToastStore} position={ToastContainer.POSITION.TOP_RIGHT}/>
                    <AlertModal message="You're leaving without completely entering incident information." isShowing={this.state.showWarningModal} cancelButton={this.handleExitButton} continueButton={this.handleContinueButton}/>
                    <Loading isShowing={this.state.linkingDispatch} message="Linking dispatch..."/>
                </div>
        )
    }

    renderArchiveButtons(){
        const {tab} = this.state;

        if (tab === 'archives'){
            return (
                <div className='header-controls'>
                    <input
                        type='text'
                        className='form-control'
                        id='archives-search-field'
                        placeholder='Search Archives...'
                        onChange={(e) => this.onSearchArchive(e.target.value)}
                    />
                    <Button id='merge-btn' className='green-btn' onClick={this.onMergeDispatch}>
                        Merge Dispatch
                    </Button>
                    <Button id='link-btn' className='blue-btn' onClick={this.onLinkDispatch}>
                        Link Dispatch
                    </Button>
                </div>
            )
        }else {
            return null
        }
    }

    onMergeDispatch = () =>{
        const {selected} = this.state;

        if(selected && selected.length){
            if(selected.length > 2){
                ToastStore.error('Cannot merge more than two dispatch. Please select only two dispatch.');
            } else {
                this.setState({
                  showMergeModal: true
                })
            }
        }else{
            ToastStore.error('Please select dispatches to merge.');
        }
    }

    onLinkDispatch = () =>{
        const that = this;
        const {selected} = this.state;

        if(selected && selected.length){
            if(selected.length === 1){
                ToastStore.error('Cannot link one dispatch. Please select more dispatch');
            }else{
                const ids = [];

                for(let x = 0; x < (selected).length; x++){
                    const {id} = selected[x];

                    if(ids.indexOf(id) === -1) ids.push(id);
                }

                this.setState({
                    linkingDispatch:true
                });

                DispatchService.sharedInstance.link(ids)
                    .then(res => {
                        if(res){
                            this.getDispatches();
                            that.setState({
                                reload:true,
                                selected:[],
                            },() => {
                                that.setState({ reload:false });
                            });

                            setTimeout( function(){
                                that.setState({
                                    linkingDispatch:false
                                });
                                ToastStore.success('Dispatch successfully linked.');
                            }, 1000);

                        }else{
                            ToastStore.error('Something went wrong with the request. Please try again later.');
                        }
                    }).catch(err => {
                        console.error('Error',err);
                        setTimeout( function(){
                            that.setState({
                                linkingDispatch:false
                            });
                            ToastStore.error(err.message);
                        }, 1000);
                    });
            }
        }else{
            ToastStore.error('Please select dispatches to link');
        }
    }

    onSearchArchive = (search) =>{
        this.setState({ search });
    }

    onSelectDispatch = (selected) =>{
        this.setState({ selected });
    }

    handleSelect(eventKey){
        console.log('current event key', eventKey);
        // let mode = eventKey != 5 ? false : true;
        this.setState({eventKey: eventKey});
    }

    handleChangeTab(){
        document.getElementById('incidents-tab-tab-archives').click();
    }

    showConfirmationModal(){
        this.setState({eventKey: 2, showWarningModal: true});
    }

    editTabTitle(key){
        const that = this;
        const {tabs} = this.state;
        const hasEdit = tabs[key] && tabs[key].hasEdit ? tabs[key].hasEdit : false;

        return (
            <div>{"Edit Dispatch"}
                <Glyphicon
                    glyph="remove" className="pull-right"
                    style={{cursor: "pointer", marginLeft: 15}}
                    onClick={(e)=>{
                        e.stopPropagation();
                        if(hasEdit){
                            if(this.state.setSettingsModal) {
                                this.state.setSettingsModal(true);
                            }
                        }else{
                            that.onCancelEditTab(key)
                        }
                        

                    }}/>
            </div>
        )
    }

    handleChangeTabEdit(){
        if (this.state.onEditMode == true && this.editTabRendered == false){
            this.timer = setTimeout(() => {
                this.editTabRendered = true;
                document.getElementById('incidents-tabs-tab-5').click();
                this.stopTimer();
            }, 1000)
        }
    }

    stopTimer(){
        console.log('clear timer');
        clearTimeout(this.timer);
    }

    handleEditIncident(itemToEdit){
        this.setState({onEditMode: true, itemToEdit: itemToEdit});
    }

    deleteIncidents(){
        console.log('about to delete');
        this.archiveChild.current.onDeleteItem();
    }

    getFormDataByType(dropDownName){ //index used in then() block
        var type = dropDownName.replace(" ", "_");

        const storedCredenials = this.state.storedCredenials;
        const loginResponse = storedCredenials.loginResponse;

        var params = {
            "license":loginResponse.data[0].User_License,
            "auth_username":loginResponse.data[0].User_ID,
            "token":loginResponse.token_data.token,
            "type":type
        };


        FormdataService.sharedInstance.getFormDataByType(params)
        .then((response)=>{
            if(type == "Incident_Type"){
                this.setState({
                    incident_types: response
                });
            }
            else if(type == "Facility"){
                this.setState({
                    facilities: response
                });
            }
            else if(type == "Facility_Location"){
                this.setState({
                    facility_locations: response
                });
            }
            else if (type == "Auto_Email"){
                this.setState({
                    auto_emails: response
                })
            }
            else if(type == "Call_Type"){
                this.setState({
                    call_types: response
                });
            }
        })
        .catch((error)=>{
            console.log("getFormDataByType error: ", error);
        });
    }

    getUsersOnDuty(){ //index used in then() block
        UsersService.sharedInstance.getUsersOnDuty()
        .then((response)=>{
            this.setState({"users_on_duty":response});
        })
        .catch((error)=>{
            console.log("getUsersOnDuty error: ", error);
        });
    }

    getForms = () =>{
        const that = this;
        const storedCredenials = this.state.storedCredenials;
        const loginResponse = storedCredenials.loginResponse;

        const param = {
            'license':loginResponse.data[0].User_License,
            'auth_username':loginResponse.data[0].User_ID,
            'token':loginResponse.token_data.token,
        };

        FormsService.sharedInstance.getAllFormsByLicense(param)
            .then(res => {
                let forms = [];

                if(res && res.length){
                    forms = res;
                }

                that.setState({ forms });
            }).catch(err => {
                console.error('Error',err);
            });
    }

    handleExitButton(){
        this.handleChangeTab();
        this.editTabRendered = false;
        this.setState({eventKey: 2, showWarningModal: false, onEditMode: false});
    }

    handleContinueButton(){
        this.setState({showWarningModal: false});
    }

    openEditTab(itemToEdit) {
      const {tabs} = this.state;
      tabs.splice(
          (tabs.length),
          0,
          {
              type:'edit',
              index:tabs.length,
              key:'edit-dispatch',
              label:'Edit Dispatch',
              removable:true
          }
      );
      this.setState({
        itemToEdit: itemToEdit,
        tabs: tabs,
        tab: "edit-"+(tabs.length-1),
      })

    }

    getDispatches = () =>{
      const that = this;
      DispatchService.sharedInstance.getAll()
        .then(res => {
            let dispatches = [];

            if(res && res.length){
                dispatches = res;
            }
            that.setState({ dispatches });

        }).catch(err => {
            console.error('Error',err);
        });
    }

    setSetSettingsModal(set) {
      this.setState({
        setSettingsModal: set
      })
    }

    setShowMergeModal(set) {
      this.setState({
        showMergeModal: set
      })
    }
}

export default Dispatch;
